import script from "./LoadingOverlay.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoadingOverlay.vue?vue&type=script&lang=ts&setup=true"

import "./LoadingOverlay.vue?vue&type=style&index=0&id=2f1e8826&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f1e8826"]])

export default __exports__